<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <div>
          <p class="text-uppercase text-muted mb-1 super-page-kicker">Configuration</p>
          <h2 class="h3 mb-0">Add New Site</h2>
        </div>
        <user-data></user-data>

      </div>
    </nav>
    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Add New Site</h3>
                </div>
                <div class="col text-right">
                    <router-link :to="{name: 'siteManagement'}" class="btn btn-info">Back</router-link>
                </div>
              </div>
            </div>
            <div>
                <b-form>
                    <div v-if="validationMessage" class="alert alert-warning mx-4 mt-4 mb-0">
                        {{ validationMessage }}
                    </div>
                    <div class="row m-0">
                        <b-form-group label="Site Name" label-for="siteName" class="col-md-4">
                            <b-form-input id="siteName" type="text" v-model="form.name"
                                placeholder="Enter site short name"  :class="{'is-invalid' : error.name}">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Site Full Name" label-for="siteFullName" class="col-md-4">
                            <b-form-input id="siteFullName" type="text" v-model="form.fullname"
                                placeholder="Enter site full name" :class="{'is-invalid' : error.fullname}">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group id="serviceProvider" label="Service Provider" label-for="serviceProvider" class="col-md-4">
                            <b-form-select v-model="form.service_provider_id" class="form-control custom-select" :class="{'is-invalid' : error.service_provider_id}">
                                <option :value="null" disabled>Select service provider</option>
                                <option v-for="sp in serviceProviders"  :key="sp.id" v-bind:value="sp.id">{{sp.name}}</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="row m-0 mb-4">
                        <div class="col-md-3">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" id="water" v-model="form.water.status" type="checkbox" :class="{'is-invalid' : error.waterStatus}">
                                <label class="custom-control-label" for="water">Water</label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" id="electricity" v-model="form.electricity.status" type="checkbox" :class="{'is-invalid' : error.electricityStatus}">
                                <label class="custom-control-label" for="electricity">Electricity</label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" id="gas" v-model="form.gas.status" type="checkbox" :class="{'is-invalid' : error.gasStatus}">
                                <label class="custom-control-label" for="gas">Gas</label>
                            </div>
                        </div>
                    </div>
                    <div class="row m-0"  v-if="form.water.status || form.electricity.status || form.gas.status">
                        <div class="col-md-12">
                            <b-card no-body>
                                <b-tabs pills card>
                                    <b-tab title="Water" v-if="form.water.status">
                                        <div class="row m-0">
                                            <b-form-group label="Description" label-for="waterDescription" class="col-md-12">
                                                <b-form-textarea id="waterDescription" v-model="form.water.description" row="3"
                                                    placeholder="Enter water Description" :class="{'is-invalid' : error.waterDescription}">
                                                </b-form-textarea>
                                            </b-form-group>
                                            <b-form-group label="CWA Rate" label-for="cwaRate" class="col-md-4">
                                                <!-- <b-form-select id="cwaRate" v-model="form.water.cwa_rate_management_id" :options="rateList.data" /> -->
                                                <b-form-select v-model="form.water.cwa_rate_management_id" :class="{'is-invalid' : error.waterCwa_rate_management_id}">
                                                    <option v-for="(rate, indexOpt) in rateList.data"
                                                        :key="indexOpt"
                                                        :value="rate"
                                                    >
                                                    {{ rate.name }}
                                                    </option>
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group label="WMA Rate" label-for="wmaRate" class="col-md-4">
                                                <!-- <b-form-select id="wmaRate" v-model="form.water.wma_rate_management_id" :options="rateList.data" /> -->
                                                <b-form-select v-model="form.water.wma_rate_management_id" :class="{'is-invalid' : error.waterWma_rate_management_id}">
                                                    <option v-for="(rate, indexOpt) in rateList.data"
                                                        :key="indexOpt"
                                                        :value="rate"
                                                    >
                                                    {{ rate.name }}
                                                    </option>
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group label="Payment Terms (In Days)" label-for="waterPaymentTerms" class="col-md-4">
                                                <b-form-input type="number" min="0" id="waterPaymentTerms" v-model="form.water.payment_terms"
                                                    placeholder="Enter Payment Terms" :class="{'is-invalid' : error.waterPayment_terms}">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Service Charge (If Billable)" label-for="waterServiceCharge" class="col-md-4">
                                                <b-form-input type="number" id="waterServiceCharge" v-model="form.water.service_charge"
                                                    placeholder="Enter service charge">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Meter Rental (If Billable)" label-for="waterMeterRental" class="col-md-4">
                                                <b-form-input type="number" id="waterMeterRental" v-model="form.water.meter_rental"
                                                    placeholder="Enter meter rental">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Custom Message" label-for="waterMsg" class="col-md-12">
                                                <b-form-textarea id="waterMsg" v-model="form.water.custom_message"
                                                    placeholder="Enter custom message">
                                                </b-form-textarea>
                                            </b-form-group>
                                        </div>
                                    </b-tab>
                                    <b-tab title="Electricity" v-if="form.electricity.status">
                                        <div class="row m-0">
                                            <b-form-group label="Description" label-for="electricityDescription" class="col-md-12">
                                                <b-form-textarea id="electricityDescription" v-model="form.electricity.description"
                                                    placeholder="Enter Electricity Description" :class="{'is-invalid' : error.electricityDescription}">
                                                </b-form-textarea>
                                            </b-form-group>
                                            <b-form-group label="Rate" label-for="electricityRate" class="col-md-4">
                                                <!-- <b-form-select id="electricityRate" v-model="form.electricity.rate_management_id" :options="rateList.data" /> -->
                                                <b-form-select v-model="form.electricity.rate_management_id" :class="{'is-invalid' : error.electricityRate_management_id}">
                                                    <option v-for="(rate, indexOpt) in rateList.data"
                                                        :key="indexOpt"
                                                        :value="rate"
                                                    >
                                                    {{ rate.name }}
                                                    </option>
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group label="Payment Terms (In Days)" label-for="electricityPaymentTerms" class="col-md-4">
                                                <b-form-input type="number" min="0" id="electricityPaymentTerms" v-model="form.electricity.payment_terms"
                                                    placeholder="Enter Payment Terms" :class="{'is-invalid' : error.electricityPayment_terms}">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Service Charge (If Billable)" label-for="electricityServiceCharge" class="col-md-4">
                                                <b-form-input type="number" id="electricityServiceCharge" v-model="form.electricity.service_charge"
                                                    placeholder="Enter service charge">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Meter Rental (If Billable)" label-for="electricityMeterRental" class="col-md-4">
                                                <b-form-input type="number" id="electricityMeterRental" v-model="form.electricity.meter_rental"
                                                    placeholder="Enter meter rental">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Custom Message" label-for="electricityMsg" class="col-md-12">
                                                <b-form-textarea id="electricityMsg" v-model="form.electricity.custom_message"
                                                    placeholder="Enter custom message">
                                                </b-form-textarea>
                                            </b-form-group>
                                            <!-- <div class="col-md-4 pt-4">
                                                <div class="custom-control custom-checkbox mt-3">
                                                    <input class="custom-control-input" id="loadBased" v-model="form.electricity.load_based" type="checkbox">
                                                    <label class="custom-control-label" for="loadBased">Load Based</label>
                                                </div>
                                            </div> -->
                                        </div>
                                    </b-tab>
                                    <b-tab title="Gas" v-if="form.gas.status">
                                        <div class="row m-0">
                                            <b-form-group label="Description" label-for="gasDescription" class="col-md-12">
                                                <b-form-textarea id="gasDescription" v-model="form.gas.description"
                                                    placeholder="Enter Gas Description" :class="{'is-invalid' : error.gasDescription}">
                                                </b-form-textarea>
                                            </b-form-group>
                                            <b-form-group label="Rate" label-for="gasRate" class="col-md-4">
                                                <!-- <b-form-select id="gasRate" v-model="form.gas.rate_management_id" :text-field="name" :options="rateList.data" /> -->
                                                <b-form-select v-model="form.gas.rate_management_id" :class="{'is-invalid' : error.gasRate_management_id}">
                                                    <option v-for="(rate, indexOpt) in rateList.data"
                                                        :key="indexOpt"
                                                        :value="rate"
                                                    >
                                                    {{ rate.name }}
                                                    </option>
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group label="Payment Terms (In Days)" label-for="gasPaymentTerms" class="col-md-4">
                                                <b-form-input type="number" min="0" id="gasPaymentTerms" v-model="form.gas.payment_terms"
                                                    placeholder="Enter Payment Terms" :class="{'is-invalid' : error.gasPayment_terms}">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Service Charge (If Billable)" label-for="gasServiceCharge" class="col-md-4">
                                                <b-form-input type="number" id="gasServiceCharge" v-model="form.gas.service_charge"
                                                    placeholder="Enter service charge">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Meter Rental (If Billable)" label-for="gasMeterRental" class="col-md-4">
                                                <b-form-input type="number" id="gasMeterRental" v-model="form.gas.meter_rental"
                                                    placeholder="Enter meter rental">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Custom Message" label-for="gasMsg" class="col-md-12">
                                                <b-form-textarea id="gasMsg" v-model="form.gas.custom_message"
                                                    placeholder="Enter custom message">
                                                </b-form-textarea>
                                            </b-form-group>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </div>
                    </div>
                    <div class="row m-0 py-4">
                        <div class="col-md-12">
                            <b-button @click="addSite(form)" type="button" variant="success" class="mr-3">Add Site</b-button>
                            <!-- <b-link @click="hideModal()">Cancel</b-link> -->
                            <router-link :to="{name: 'siteManagement'}" >Back</router-link>
                        </div>
                    </div>
                </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import userData from '@/pages/Common/userData';

  export default {
    components: {
      userData
    },
    data () {
      return {
        form : {
            name:'',
            fullname: '',
            service_provider_id: null,
            water: {
                status:false,
                custom_message: '',
                description: '',
                cwa_rate_management_id: '',
                wma_rate_management_id: '',
                service_charge: '',
                meter_rental: '',
                payment_terms: ''
            },
            electricity: {
                status:false,
                rate_management_id: '',
                description: '',
                service_charge: '',
                meter_rental: '',
                custom_message: '',
                payment_terms: '',
                load_based: false
            },
            gas:{
                status:false,
                rate_management_id: '',
                description: '',
                service_charge: '',
                meter_rental: '',
                payment_terms: '',
                custom_message: ''
            }
        },
        serviceProviders: [],
        errorFlag: false,
        error:{ },
        validationMessage: ''
      }
    },
    computed: {
      ...mapGetters('siteManagement', ['serviceProviderList', 'rateList']),
    },
    methods: {
      ...mapActions('siteManagement', ['FETCH_SERVICE_PROVIDER', 'FETCH_RATES', 'ADD_SITE']),
      getServiceProvider () {
        return this.FETCH_SERVICE_PROVIDER().then(()=>{
          this.serviceProviders = this.serviceProviderList.data
        }).catch(() => { }).then(() => {
          return this.FETCH_RATES().catch(() => { })
        })
      },
      validateSiteForm (data) {
        this.error = {
            name: false,
            fullname: false,
            service_provider_id: false,
            waterStatus: false,
            electricityStatus: false,
            gasStatus: false,
            waterDescription:false,
            waterCwa_rate_management_id: false,
            waterWma_rate_management_id:false,
            waterPayment_terms: false,
            electricityDescription: false,
            electricityRate_management_id: false,
            electricityPayment_terms: false,
            gasDescription: false,
            gasRate_management_id: false,
            gasPayment_terms: false
        }
        this.errorFlag = false
        const validationErrors = []
        if (!data.name) {
          validationErrors.push('Enter a site name.')
          this.errorFlag = true
          this.error.name = true
        }
        if (!data.fullname) {
            validationErrors.push('Enter a site full name.')
            this.errorFlag = true
            this.error.fullname = true
        }
        if (!data.service_provider_id) {
            validationErrors.push('Select a service provider.')
            this.errorFlag = true
            this.error.service_provider_id = true
        }

        if(!data.water.status && !data.electricity.status && !data.gas.status) {
            validationErrors.push('Select at least one service.')
            this.errorFlag = true
            this.error.waterStatus= true
            this.error.electricityStatus= true
            this.error.gasStatus= true
        }
        if (data.water.status) {
            if(!data.water.description) {
                validationErrors.push('Enter a water description.')
                this.errorFlag = true
                this.error.waterDescription = true
            } else if(!data.water.cwa_rate_management_id) {
                validationErrors.push('Select a CWA rate.')
                this.errorFlag = true
                this.error.waterCwa_rate_management_id = true
            } else if(!data.water.wma_rate_management_id) {
                validationErrors.push('Select a WMA rate.')
                this.errorFlag = true
                this.error.waterWma_rate_management_id = true
            } else if(!data.water.payment_terms) {
                validationErrors.push('Enter water payment terms.')
                this.errorFlag = true
                this.error.waterPayment_terms = true
            }
        }
        if(data.electricity.status) {
            if(!data.electricity.description) {
                validationErrors.push('Enter an electricity description.')
                this.errorFlag = true
                this.error.electricityDescription = true
            } else if(!data.electricity.rate_management_id) {
                validationErrors.push('Select an electricity rate.')
                this.errorFlag = true
                this.error.electricityRate_management_id = true
            } else if(!data.electricity.payment_terms) {
                validationErrors.push('Enter electricity payment terms.')
                this.errorFlag = true
                this.error.electricityPayment_terms = true
            }
        }
        if(data.gas.status){
            if(!data.gas.description) {
                validationErrors.push('Enter a gas description.')
                this.errorFlag = true
                this.error.gasDescription = true
            } else if(!data.gas.rate_management_id) {
                validationErrors.push('Select a gas rate.')
                this.errorFlag = true
                this.error.gasRate_management_id = true
            } else if(!data.gas.payment_terms) {
                validationErrors.push('Enter gas payment terms.')
                this.errorFlag = true
                this.error.gasPayment_terms = true
            }
        }
        this.validationMessage = validationErrors[0] || ''
      },
      addSite(data) {
        this.validateSiteForm (data)

        if(!this.errorFlag) {
            let siteData = {
                name: data.name,
                fullname: data.fullname,
                service_provider_id: data.service_provider_id
            }
            if (data.water.status) {
                siteData.water = {
                    description: data.water.description,
                    cwa_rate_management_id: data.water.cwa_rate_management_id.id,
                    wma_rate_management_id: data.water.wma_rate_management_id.id,
                    service_charge: data.water.service_charge,
                    meter_rental: data.water.meter_rental,
                    payment_terms:  data.water.payment_terms,
                    custom_message: data.water.custom_message
                }
            }
            if (data.electricity.status) {
                siteData.electricity = {
                    rate_management_id : data.electricity.rate_management_id.id,
                    description : data.electricity.description,
                    service_charge : data.electricity.service_charge,
                    meter_rental : data.electricity.meter_rental,
                    payment_terms : data.electricity.payment_terms,
                    custom_message : data.electricity.custom_message,
                    load_based : data.electricity.load_based
                }
            }
            if (data.gas.status) {
                siteData.gas = {
                    rate_management_id: data.gas.rate_management_id.id,
                    description: data.gas.description,
                    service_charge: data.gas.service_charge,
                    meter_rental: data.gas.meter_rental,
                    payment_terms: data.gas.payment_terms,
                    custom_message: data.gas.custom_message
                }
            }
            this.ADD_SITE(siteData).then(()=>{
              this.$router.replace({name: "siteManagement"});
            }).catch(() => {

            })
        }
      },
    },
    created () {
        this.getServiceProvider();
    }
  }
</script>
<style scoped>
.super-page-kicker {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #5e72e4;
}
</style>



// WEBPACK FOOTER //
// src/pages/SuperAdmin/addNewSite.vue